// extracted by mini-css-extract-plugin
export var btn = "singleProviderWarning-module--btn--ddef9";
export var container = "singleProviderWarning-module--container--ffc92";
export var desc = "singleProviderWarning-module--desc--46ae4";
export var fade = "singleProviderWarning-module--fade--f6905";
export var innerCtn = "singleProviderWarning-module--innerCtn--50fa3";
export var plansInner = "singleProviderWarning-module--plansInner--d263d";
export var pricingBtn = "singleProviderWarning-module--pricingBtn--17450";
export var toggleContainer = "singleProviderWarning-module--toggleContainer--4e426";
export var visible = "singleProviderWarning-module--visible--31fff";